// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Grid_anchor__GXtPf","grid":"Grid_grid__EAPIs","title":"Grid_title__aYkfN"};